import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {setResetPasswordData} from "../../slice/resetPasswordEmailSlice";


export const restorePasswordByEmail = createAsyncThunk(
    "resetPassword/resetPasswordByEmail",
    async (authData: { email: string }, thunkAPI) => {
        try {
            const response = await axios.post("/api/restore-password", authData);
            thunkAPI.dispatch(setResetPasswordData(response.data));
            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);
